var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVerticalEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#828FA3",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.308,
    cy: 2.308,
    r: 2.308
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.308,
    cy: 10,
    r: 2.308
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.308,
    cy: 17.692,
    r: 2.308
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerticalEllipsis);
export default __webpack_public_path__ + "static/media/icon-vertical-ellipsis.5c8996197d4a9dd7a7adfa20ce4abef9.svg";
export { ForwardRef as ReactComponent };